// extracted by mini-css-extract-plugin
export default {"title":"purchase_title__3wOQN","content":"purchase_content__1QUnn","heading":"purchase_heading__2jIUl","purchaseInfo":"purchase_purchaseInfo__19fpy","label":"purchase_label__3xuHF"};